import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useCurrentLocation } from '../hooks';

export default function useSocketRegistrationInfo() {
  const userIdFromRedux = useSelector((state) => state.auth?.user?.userId);
  const { location } = useCurrentLocation();

  // ✅ FIX: Fallback to localStorage if Redux not yet hydrated
  const [userIdFromStorage, setUserIdFromStorage] = useState(null);

  useEffect(() => {
    if (typeof window !== 'undefined' && !userIdFromRedux) {
      try {
        const auth = JSON.parse(localStorage.getItem('auth') || '{}');
        if (auth.userId) {
          setUserIdFromStorage(auth.userId);
          console.log(
            '[useSocketRegistrationInfo] ✅ Using userId from localStorage:',
            auth.userId
          );
        }
      } catch (e) {
        console.warn('[useSocketRegistrationInfo] localStorage read error:', e);
      }
    }
  }, [userIdFromRedux]);

  const userId = userIdFromRedux || userIdFromStorage;
  const deviceToken = typeof window !== 'undefined' ? localStorage.getItem('fcmDeviceToken') : null;

  console.log('[useSocketRegistrationInfo] 📊 Status:', {
    userId,
    hasDeviceToken: !!deviceToken,
    isLoggedIn: !!userId && !!deviceToken,
    source: userIdFromRedux ? 'redux' : userIdFromStorage ? 'localStorage' : 'none',
  });

  return {
    userId,
    deviceToken,
    location,
    isLoggedIn: !!userId && !!deviceToken,
  };
}
